import { useRecoilState } from "recoil";
import { loadingCapag } from "../atom";

const useLoadingCapagState = () => {
    return useRecoilState(loadingCapag);
};

export default useLoadingCapagState;